import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.page.css';
import MainLogo from '../../../ui/components/MainLogo';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const response = await fetch('/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(
          'Password reset instructions have been sent to your email.'
        );
        setEmail('');
        setTimeout(() => {
          navigate('/signin');
        }, 5000);
      } else {
        setError(
          data.message || 'Failed to process request. Please try again.'
        );
      }
    } catch (error) {
      setError(
        'An error occurred while processing your request. Please try again.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <MainLogo nav={navigate} />
      <div className="forgot-password-box">
        <h2 className="forgot-password-title">Forgot Password</h2>
        {error && <div className="forgot-password-error">{error}</div>}
        {success && <div className="forgot-password-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            className="forgot-password-input"
            placeholder="abc@xyz.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError('');
              setSuccess('');
            }}
            required
            disabled={isLoading}
          />
          <button
            type="submit"
            className="forgot-password-button"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Reset Instructions'}
          </button>
        </form>

        <p className="forgot-password-links">
          Remember your password? <a href="/signin">Sign In</a>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
